import { ProductType } from '@shared/models/product-type';
import { Badge } from '@shared/shared/modules/card/components/badge/badge.component';

export interface Card {
  showMoreInfo?: boolean;
  darkTheme?: boolean;
  cardWidth?: string;
  imageUrl?: string;
  image_url?: string;
  backupImageUrl?: string;
  imageClass?: string;
  ribbon?: CardRibbon;
  ribbonFullWidth?: boolean;
  followButton?: FollowButton;
  tourAnchorId?: string;
  id?: number | string;
  body?: CardBody;
  likeable?: boolean;
  liked?: boolean;
  size?: 'regular' | 'small';
  cardStyle: CardStyleEnum;
  cardType?: string;
  url?: string;
  params?: { [key: string]: string };
  filters?: FilterProperties;
  time_slots?: TimeSlot[];
  type?: string;
  instalmentPaymentsAvailable?: boolean;
  instalmentBannerText?: string;
  badgesOnTop?: boolean;
  promotedHotelBannersAsFHR?: boolean;
  primaryInterest?: PrimaryInterest;
  category?: string;
  isESG?: boolean;
  availabilityStatus?: number;
}

export interface PrimaryInterest {
  id?: number;
  name?: string;
  is_preferred?: boolean;
  interest_type: string;
}

export interface FilterProperties {
  memberBenefit?: boolean;
  heldTable?: boolean;
  cuisines?: number[];
  category?: number[];
  esgCategory?: number[];
}

export interface TimeSlot {
  booking_token: string;
  start_date_full: string;
}

export interface CardRibbon {
  productGroup?: string;
  text: string;
  filled?: boolean;
  style?: RibbonStyleEnum;
  type?: RibbonTypeEnum;
}

export interface FollowButton {
  style?: FollowButtonStyleEnum;
  preferred?: boolean;
  preferenceTracking?: PreferenceTracking;
  texts?: ToggleTranslationKeys;
  followTipTexts?: ToggleTranslationKeys;
  toolTipTexts?: ToggleTranslationKeys;
  favourite?: boolean;
  product: {
    type: ProductType;
    id: number;
    name: string;
    category?: string;
  };
  notificationTexts?: NotificationTexts;
  readonly?: boolean;
}

export type CardPreferenceState = { [key: string | number]: boolean };

export interface NotificationTexts {
  labels: ToggleTranslationKeys;
  ariaLabels?: ToggleTranslationKeys;
}

export interface ToggleTranslationKeys {
  on: string;
  off: string;
  params?: { [key: string]: string };
}

export interface PreferenceTracking {
  eventName: string;
  data: { [id: string]: any };
}

export interface CardBody {
  heading?: string;
  text?: string;
  booking?: CardBooking;
  status?: CardStatus;
  badges?: Badge[];
  tags?: CardTag[];
  rating?: number;
  contentSections?: CardBodyContent[];
  valueProposition?: string;
  price?: { price: string; currency: string };
  showAmenityLearnMore?: boolean;
  availableFrom?: Date;
  availableUntil?: Date;
  isNewOffer?: boolean;
  expiringSoon?: boolean;
  randomTwoTags?: string[];
  has_benefits?: boolean;
  benefit?: string;
  firstDateAvailable?: string;
  availableDatesCount?: number;
}

export interface CardTag {
  id: number;
  text: string;
}

export interface CardBodyContent {
  content: string[];
}

interface CardBooking {
  description?: string;
  time?: string;
  date?: string;
}

interface CardStatus {
  healthy: boolean;
  description?: string;
  descriptionKey?: string;
}

export enum CardStyleEnum {
  float = 'float',
  halfnhalf = 'halfnhalf',
  halfnhalf_alt = 'halfnhalf_alt',
  article = 'article',
  horizontal = 'horizontal',
  horizontal_alt = 'horizontal_alt',
  minimal = 'minimal',
  minimal_alt = 'minimal-alt',
}

export enum RibbonStyleEnum {
  minimal = 'minimal',
  arrow = 'arrow',
}

export enum FollowButtonStyleEnum {
  Bordered = 'bordered',
  Round = 'round',
  Shadowed = 'shadowed',
}

export enum RibbonTypeEnum {
  MemberFavourite = 'MemberFavourite',
  Exclusive = 'Exclusive',
  MemberBenefitPriceless = 'MemberBenefitPriceless',
  ConciergeSelection = 'ConciergeSelection',
  PremiumAccess = 'PremiumAccess',
  ExclusiveOffer = 'ExclusiveOffer',
  Presale = 'Presale',
  ExclusivePresale = 'ExclusivePresale',
}

export const attributeIdMapper: { [key: number]: string } = {
  3: 'EntertainmentExclusiveLabel:ConciergeSelection',
  4: 'EntertainmentExclusiveLabel:PremiumAccess',
  5: 'EntertainmentExclusiveLabel:ExclusiveOffer',
  6: 'EntertainmentExclusiveLabel:Presale',
  7: 'EntertainmentExclusiveLabel:ExclusivePresale',
};

export const ribbonTypeMapper: { [key: string]: RibbonTypeEnum } = {
  3: RibbonTypeEnum.ConciergeSelection,
  4: RibbonTypeEnum.PremiumAccess,
  5: RibbonTypeEnum.ExclusiveOffer,
  6: RibbonTypeEnum.Presale,
  7: RibbonTypeEnum.ExclusivePresale,
};
